import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../api/client';
import CloseBar from '../components/CloseBar';

export default function LoginPage({ onLogin }) {
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError('');
    try {
      const { data } = await api.login(form);
      onLogin(data.access_token, data.paid);
    } catch {
      setError('Неверный email или пароль');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.box}>
        <CloseBar />
        <div style={styles.logo}>✦ AstraData</div>
        <h2 style={styles.title}>Войти в аккаунт</h2>
        <p style={styles.sub}>Ведическая астрология для выбора даты покупки недвижимости</p>

        <form onSubmit={submit} style={styles.form}>
          <div className="input-group">
            <label>Email</label>
            <input className="input" type="email" placeholder="you@email.com"
              value={form.email} onChange={e => setForm({...form, email: e.target.value})} required />
          </div>
          <div className="input-group">
            <label>Пароль</label>
            <input className="input" type="password" placeholder="••••••••"
              value={form.password} onChange={e => setForm({...form, password: e.target.value})} required />
          </div>
          {error && <p style={styles.error}>{error}</p>}
          <button className="btn btn-primary" type="submit" disabled={loading} style={{width:'100%'}}>
            {loading ? 'Вход...' : 'Войти'}
          </button>
        </form>

        <p style={styles.footer}>
          Нет аккаунта? <Link to="/register" style={styles.link}>Зарегистрироваться</Link>
        </p>
      </div>
    </div>
  );
}

const styles = {
  page:  { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 },
  box:   { width: '100%', maxWidth: 420, background: '#1a1a2e', border: '1px solid #2a2a4a', borderRadius: 20, padding: 40 },
  logo:  { fontSize: 22, fontWeight: 700, color: '#a78bfa', marginBottom: 24, textAlign: 'center' },
  title: { fontSize: 24, marginBottom: 8, textAlign: 'center' },
  sub:   { fontSize: 13, color: '#666680', textAlign: 'center', marginBottom: 28, lineHeight: 1.5 },
  form:  { display: 'flex', flexDirection: 'column', gap: 16 },
  error: { color: '#e74c3c', fontSize: 13, textAlign: 'center' },
  footer:{ marginTop: 24, textAlign: 'center', fontSize: 14, color: '#666680' },
  link:  { color: '#a78bfa', textDecoration: 'none' },
};
